import { render } from "./IncomesAndOutcomes.vue?vue&type=template&id=5a0ea93b"
import script from "./IncomesAndOutcomes.vue?vue&type=script&lang=js"
export * from "./IncomesAndOutcomes.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__